
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const OnlineCreativeLanding = dynamic(async () => await import('@/templates/Landing/OnlineCreative/OnlineCreativeLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='Generate Thousands of AI-Powered Ad Creatives with Lift' description='Boost your ad performance with Lift’s AI-driven creative tools. Instantly generate thousands of professional, brand-consistent ad variations without the need for designers or time-consuming manual work. Perfect for marketing teams, DTC brands, and small businesses.' ogTitle='Create High-Quality Ad Creatives Instantly with Lift AI' ogDescription='Discover how Lift’s AI tools help you generate, customize, and scale ad creatives effortlessly — saving time, optimizing branding, and accelerating your marketing campaigns.'>
				<OnlineCreativeLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/online-ad-creatives', 'online-ad-creatives');

    async function __Next_Translate__getServerSideProps__1a1a20bb8cf__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/online-ad-creatives/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8cf__ as getServerSideProps }
  